import React from 'react';
import Blankslate from 'common/oldJavascripts/components/Base/Blankslate';
import Box from 'common/oldJavascripts/components/Base/Box';
import Table from 'common/oldJavascripts/components/Base/Table';
import Pagination from 'common/oldJavascripts/components/Base/Pagination';
import Header from 'common/oldJavascripts/components/Base/Header';
import T from 'common/oldJavascripts/utils/i18n';
import Relay from 'common/oldJavascripts/utils/react/Relay.js';
import Loader from 'common/components/Loader';
import ArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import history from 'common/constants/config/history';
import moment from 'moment';
import qs from 'qs';
import { withStyles } from '@material-ui/core/styles';
import Badges from 'common/components/Badges';
import QueryRefresher from 'common/components/QueryRefresher';
import BoxItem from 'common/oldJavascripts/components/Base/Box/BoxItem';

const styles = () => ({
  loader: {
    backgroundColor: 'white',
    width: '100%',
    height: '200px',
  },
  badgesContainer: {
    marginLeft: 6,
  },
  projectName: {
    overflow: 'visible',
    wordWrap: 'break-word',
  },
});

const { Cell, Row } = Table;

const CrewOfferTable = Relay.createClass({
  statics: {
    queries: {
      offers: {
        info(params, related) {
          const query = related['/router/query'];
          return {
            cursor: {
              page: query[`${params.status}-page`] || 1,
              per_page: query.per_page || 10,
              sort: query.sort,
              direction: query.direction,
              q: params.status,
            },
            expires: true,
            id: '/v2/offers',
          };
        },
      },
    },
  },

  _changeOffersPage(page) {
    const {
      routerPath,
      routerQuery = {},
      params: { status } = {},
    } = this.props;
    history.push({
      pathname: routerPath,
      search: qs.stringify({
        ...routerQuery,
        [`${status}-page`]: page,
      }),
    });
  },

  render() {
    const { offers: offersQuery = {}, type, classes = {} } = this.props;
    const { status: offersStatus, data: offersData = {}, reload: reloadQuery } =
      offersQuery || {};
    const {
      items: offers = [],
      total_pages: offersNumberOfPages,
      page: offersCurrentPage,
    } = offersData || {};

    const cellConfigs = {
      sent: ['project_name', 'occupation_description', 'sent_at', 'rightArrow'],
      submitted: [
        'project_name',
        'occupation_description',
        'sent_at',
        'rightArrow',
      ],
      approved: [
        'project_name',
        'occupation_description',
        'sent_at',
        'approved_at',
        'rightArrow',
      ],
      employeeRejected: [
        'project_name',
        'occupation_description',
        'sent_at',
        'rejected_at',
        'rejection_comments',
        'rightArrow',
      ],
      optedOut: [
        'project_name',
        'occupation_description',
        'sent_at',
        'rightArrow',
      ],
    };

    const headerLabels = {
      approved_at: 'Approved Date',
      project_name: 'Project Name',
      occupation_description: 'Position',
      sent_at: 'Sent Date',
      rejected_at: 'Rejected Date',
      rejection_comments: 'Reason For Rejection',
      rightArrow: '',
    };

    const customCellDisplays = {
      project_name: ({ project_name, id, badges = [] }) => (
        <Cell
          doubleBorderBottom
          rowHeader={true}
          data-test-id={`OfferTable-cell-${id}/project_name`}
          className={classes.projectName}
        >
          {project_name}
          <span className={classes.badgesContainer}>
            <Badges badges={badges} id={id} />
          </span>
        </Cell>
      ),
      approved_at: ({ approved_at, id }) => (
        <Cell
          doubleBorderBottom
          data-test-id={`OfferTable-cell-${id}/approved_at`}
        >
          {moment
            .utc(approved_at, 'YYYY-MM-DD HH:mm:ss Z')
            .local()
            .format('MM-DD-YYYY h:mmA')}
        </Cell>
      ),
      rejected_at: ({ rejected_at, id }) => (
        <Cell
          doubleBorderBottom
          data-test-id={`OfferTable-cell-${id}/rejected_at`}
        >
          {moment
            .utc(rejected_at, 'YYYY-MM-DD HH:mm:ss Z')
            .local()
            .format('MM-DD-YYYY h:mmA')}
        </Cell>
      ),
      sent_at: ({ sent_at, id }) => (
        <Cell doubleBorderBottom data-test-id={`OfferTable-cell-${id}/sent_at`}>
          {moment
            .utc(sent_at, 'YYYY-MM-DD HH:mm:ss Z')
            .local()
            .format('MM-DD-YYYY h:mmA')}
        </Cell>
      ),
      rightArrow: ({ id }) => (
        <div
          className="table-cell"
          style={{ textAlign: 'end' }}
          data-test-id={`OfferTable-cell-${id}/rightArrow`}
        >
          <ArrowRightIcon />
        </div>
      ),
    };

    const to = offer => {
      if (type === 'employeeRejected') return false;
      if (offer.can_continue === false)
        return `/projects/${offer.project_id}/change-app`;
      if (offer.status === 'sent' || offer.status === 'onboarding')
        return `/onboarding/offers/${offer.id}/details`;
      if (/^onboarding_/.test(offer.status)) {
        const onboardingStep = offer.status
          .split('_')
          .slice(1)
          .join('-');
        return `/onboarding/offers/${offer.id}/${onboardingStep}`;
      }
      if (type === 'optedOut')
        return `/onboarding/offers/${offer.id}/opted-out`;
      return `/onboarding/offers/${offer.id}/submitted`;
    };
    const tableBody = () =>
      offers.map(offer => {
        const cells = cellConfigs[type].map(key => {
          if (customCellDisplays[key]) return customCellDisplays[key](offer);
          return (
            <Cell
              doubleBorderBottom
              data-test-id={`OfferTable-cell-${offer.id}/${key}`}
              className={classes.projectName}
            >
              {offer[key]}
            </Cell>
          );
        });
        return (
          <Row
            key={offer.id}
            to={to(offer)}
            data-test-id={`OfferTable-row-${offer.id}`}
          >
            {cells}
          </Row>
        );
      });

    const tableHeaders = () =>
      cellConfigs[type].map(key => (
        <Cell
          key={key}
          header={true}
          data-test-id={`OfferTable-headerRow-${type}/${key}`}
        >
          {headerLabels[key]}
        </Cell>
      ));

    const renderContent = () => {
      if (offersStatus === 'loading')
        return <Loader className={classes.loader} />;
      if (offers.length === 0)
        return (
          <Blankslate>{T(`employee.offers.${type}.empty_list`)}</Blankslate>
        );

      return (
        <Table>
          <Table.Header>{tableHeaders()}</Table.Header>
          {tableBody()}
        </Table>
      );
    };

    return (
      <div>
        <Box>
          <BoxItem>
            <Header>
              <Header.Title data-test-id={`Table-header-${type}`}>
                {T('employee.offers.' + type + '.label')}
              </Header.Title>
              <QueryRefresher reloadQuery={reloadQuery} />
            </Header>
          </BoxItem>
          {renderContent()}
        </Box>
        <Pagination
          totalPages={offersNumberOfPages}
          page={offersCurrentPage}
          onChange={this._changeOffersPage}
        />
      </div>
    );
  },
});

export default withStyles(styles)(CrewOfferTable);
